import type { ApiTransportOrder } from '#api/tourservice/model/types.ts';
import type { TransportOrder } from '#domain/model/TransportOrder.ts';

import { mapGoods } from './goodsAdapter.ts';

export const mapTransportOrder = (transportOrder: ApiTransportOrder): TransportOrder => ({
    id: transportOrder.id,
    external_id: transportOrder.external_id,
    reference_id: transportOrder.reference_id,
    secondary_reference_id: transportOrder.secondary_reference_id,
    contact: transportOrder.contact,
    loading: transportOrder.loading,
    unloading: transportOrder.unloading,
    goods: transportOrder.goods ? mapGoods(transportOrder.goods) : undefined,
});

export const mapTransportOrders = (stops: ApiTransportOrder[]): TransportOrder[] => stops.map(mapTransportOrder);
